<template>
  <div class="member">
    <fixed-header class="member__success-fixheader" title="会员购买"></fixed-header>
    <div v-infinite-scroll="getNextVipGoods" :infinite-scroll-disabled="loading"
         :infinite-scroll-distance="30"
         class="member__success scroll-touch">
      <div class="member__success-header">
        <p class="card">{{ productName }}</p>
        <p v-if="paystatus==1" class="desc"><span>开通成功</span></p>
        <p v-else class="desc no-backgroud"><span>支付结果查询中</span></p>
      </div>
      <div class="member__success-goods">
        <p class="member__success-goods-title">会员专享商品</p>
        <div class="member__success-goods-list">
          <recommend :goods="goods"></recommend>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import Recommend from 'components/member/Recommend';
import { goods, order } from 'apis/member';
import { getQueryParams } from 'utils';
import Env from 'utils/env';
import MgtvApi from 'MgtvApi';
import MgStat from 'MgStat';

export default {
  components: { FixedHeader, Recommend },
  created() {
    this.fetchOrderStatus();
    this.getProductName();
    MgStat.send('pv', { order_id: this.orderId }, { cntp: 'haowu_member_success' });
  },
  data() {
    const { orderId, newOrderId } = getQueryParams();
    return {
      newOrderId,
      orderId,
      goodsParam: {
        p: 1, // 页码
        limit: 6, // 页大小
      },
      goodsTotalPage: 0, // 总页数
      goods: [],
      loading: false, // 是否正在加载
      tip: '支付结果查询中...',
      paystatus: 0,
      productName: '商城会员',
    };
  },
  mounted() {
    this.getVipGoods();
  },
  methods: {
    async getVipGoods() {
      this.loading = true;
      try {
        const vipgoods = await goods(this.goodsParam);
        const goodsrecords = vipgoods.records;
        if (goodsrecords && goodsrecords.length > 0) {
          this.goods = [...this.goods, ...goodsrecords];
        }
        this.goodsTotalPage = vipgoods.pages;
        console.log(this.goodsTotalPage);
      } catch (e) {
        console.log('会员专属商品加载失败', e);
      } finally {
        this.loading = false;
      }
    },
    async getProductName() {
      try {
        const { orderId } = this;
        if (orderId) {
          const { productName, orderStatus } = await order(this.orderId);
          this.productName = productName;
          this.paystatus = orderStatus;
        }
      } catch (e) {
        console.warn(e);
      }
    },
    getNextVipGoods() {
      const page = this.goodsParam.p;
      if (page < this.goodsTotalPage) {
        this.goodsParam.p = page + 1;
        this.getVipGoods();
      }
    },
    goGoodsDetail(id) {
      this.$router.push({ path: '/goods/detail', query: { id, showBack: 1 } });
    },
    fetchOrderStatus() {
      const { orderId } = this;
      const { isMgtvApp, isWeixin } = Env;
      const hasPay = isMgtvApp || isWeixin; // 在芒果tv内或者微信内 来到当前页面  一定是支付成功的 无需根据订单状态判断
      this.paystatus = hasPay;
      if (!orderId && hasPay) {
        return;
      }
      try {
        setTimeout(async () => {
          try {
            const {
              orderStatus,
            } = await order(this.orderId);
            if (orderStatus) {
              this.tip = '开通成功 ';
              MgtvApi.setWebviewTitle({ title: '开通成功' });
              this.paystatus = 1;
            } else { /* 如果没付款 则去待支付列表 */
              // this.payStatusTitle = '支付结果';
              // MgtvApi.setWebviewTitle({ title: '支付结果' });
              // this.tip = '支付失败 ';
              // this.$router.push({ path: '/order/all', query: { type: 'WAITPAY' } });
            }
          } catch (e) {
            this.$toast(`获取订单详情失败：${e.message}`);
          }
        }, hasPay ? 0 : 2000);
      } catch (error) {
        this.$toast(`获取订单详情失败：${error.message}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.member {
  height: 100%;
  box-sizing: border-box;

  &__success {
    height: 100%;
    overflow-y: scroll;
    background-image: url("../../../assets/img/member/member_success_bg.png");
    background-repeat: no-repeat;
    background-size: 750px 270px;
    overflow: scroll;
    text-align: center;
    background-color: #fff;

    &-header {
      width: 100%;
      height: 180px;
      margin-top: 58px;
      background-size: 100% 100%;

      p {
        margin: 0 auto;
      }

      .card {
        width: 250px;
        height: 55px;
        line-height: 55px;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        background-size: 250px 55px;
        background-image: url("../../../assets/img/member/member_success_card.png");
      }

      .desc {
        margin-top: 18px;
        font-size: 34px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(227, 179, 101, 1);
        height: 55px;
        line-height: 55px;

        span {
          padding-left: 54px;
          background-image: url("../../../assets/img/member/member_success_icon.png");
          background-size: 54px 54px;
          background-position-x: 0;
          background-position-y: -2px;
          background-repeat: no-repeat;
        }
      }

      .desc.no-backgroud {
        span {
          background-image: none;
          padding-left: 0px;
        }
      }
    }

    &-goods {
      border-radius: 30px 30px 0px 0px;
      padding: 0 24px;
      padding-top: 30px;
      background-color: #fff;

      &-title {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
        line-height: 50px;
        text-align: left;
      }

      &-list {
        text-align: left;
        /*display: flex;*/
        /*justify-content: space-between;*/
      }
    }

  }
}


</style>
